import { render, staticRenderFns } from "./SelfBuildCategoryPage.vue?vue&type=template&id=425c4e5c&scoped=true&"
import script from "./SelfBuildCategoryPage.vue?vue&type=script&lang=js&"
export * from "./SelfBuildCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./SelfBuildCategoryPage.vue?vue&type=style&index=0&id=425c4e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c4e5c",
  null
  
)

export default component.exports